import { defineMessages } from 'react-intl';

export default defineMessages({
    save: {
        id: 'app.components.EditClassForm.save',
        defaultMessage: 'Save'
    },
    cancel: {
        id: 'app.components.EditClassForm.cancel',
        defaultMessage: 'Cancel'
    }
});



// WEBPACK FOOTER //
// ./app/components/edit-class-form/messages.js